export default {"src":"/_next/static/media/english.a06ee220.svg","height":480,"width":480,"blurWidth":0,"blurHeight":0};